import { Inject, Injectable, LOCALE_ID } from '@angular/core';

import { DataTransformationGoogleAnalyticsMapper } from './data-transformation-google-analytics.mapper';
import { DataTransformationSnowplowMapper } from './data-transformation-snowplow.mapper';

@Injectable()
export class DataTransformationHelper {
  snowplowMapper?: DataTransformationSnowplowMapper;
  googleAnalyticsMapper?: DataTransformationGoogleAnalyticsMapper;

  constructor(@Inject(LOCALE_ID) private locale: string) {
    this.snowplowMapper = new DataTransformationSnowplowMapper(locale);
    this.googleAnalyticsMapper = new DataTransformationGoogleAnalyticsMapper();
  }

  get snowplow() {
    return this.snowplowMapper;
  }

  get googleAnalytics() {
    return this.googleAnalyticsMapper;
  }
}
